const TranslateIcon = ()=> {
    return (
        <svg className={"svg-icon"} width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22.1934 20.25L16.9434 9.75L11.6934 20.25"  strokeWidth="2" strokeLinecap="round"
                  strokeLinejoin="round"/>
            <path d="M13.1934 17.25H20.6934"  strokeWidth="2" strokeLinecap="round"
                  strokeLinejoin="round"/>
            <path d="M8.69336 3V5.25"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M2.69336 5.25H14.6934"  strokeWidth="2" strokeLinecap="round"
                  strokeLinejoin="round"/>
            <path
                d="M11.6934 5.25C11.6934 7.63695 10.7451 9.92613 9.05732 11.614C7.36949 13.3018 5.08031 14.25 2.69336 14.25"
                strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path
                d="M6.20605 8.25C6.82753 10.004 7.97722 11.5224 9.49698 12.5963C11.0167 13.6702 12.8319 14.2468 14.6928 14.2468"
                strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export default TranslateIcon